import { IonCard, IonImg } from '@ionic/react';
import { useMemo } from 'react';

import { mergeClassNames } from '@/utils/mergeClassNames';

import PlugInIllustration from '@/assets/illustrations/PlugIllustration.svg';
import SuccessIllustration from '@/assets/illustrations/SuccessIllustration.svg';
import SyncingIllustration from '@/assets/illustrations/SyncingIllustration.svg';
import UnplugIllustration from '@/assets/illustrations/UnplugIllustration.svg';

import styles from './SensorFlowModal.module.css';

import { Button } from '../Button';

interface SensorFlowModalProps {
  illustration: 'plugIn' | 'unplug' | 'syncing' | 'success';
  description: string;
  progress?: number;
  onClick?: () => void;
  buttonText?: string;
}

export const SensorFlowModal = ({ illustration, description, progress, onClick, buttonText }: SensorFlowModalProps) => {
  // Output: <strong className={styles.strong}>text example</strong> and <i>text example</i>

  const descriptionWithHtml = useMemo(() => {
    // Replace *text* with <strong class="styles.strong">text</strong>
    let html = description.replace(/\*([^*]+)\*/g, `<strong class="${styles.strong}">$1</strong>`);

    // Replace _text_ with <i class="styles.italic">text</i>
    html = html.replace(/_([^_]+)_/g, `<i class="${styles.italic}">$1</i>`);

    return html;
  }, [description]);

  return (
    <IonCard className={styles.card}>
      <IonImg
        className={mergeClassNames(styles.illustration, buttonText && styles.reducedSpacing)}
        src={
          {
            plugIn: PlugInIllustration,
            unplug: UnplugIllustration,
            syncing: SyncingIllustration,
            success: SuccessIllustration,
          }[illustration]
        }
      />

      {progress !== undefined && (
        <div className={styles.progress}>
          <div
            className={styles.completed}
            style={
              {
                '--progress': progress,
              } as React.CSSProperties
            }
          />
        </div>
      )}

      <div
        className={styles.text}
        dangerouslySetInnerHTML={{
          __html: descriptionWithHtml,
        }}
      />

      {buttonText && (
        <Button className={styles.button} isFullWidth onClick={onClick} variant='primary'>
          {buttonText}
        </Button>
      )}
    </IonCard>
  );
};
